import QuestionList from "../../components/question/QuestionList"
const QuestionslistPage = () => {
    return(
        <QuestionList />
    )
}

export default QuestionslistPage